export default "__VITE_ASSET__mQH68dzF__"